import styles from './docDetailHeader.module.css';

interface DocDetailHeaderProps {
  activeTab: number;
  setActiveTag: (tab: number) => void;
  onClose: () => void;
}

function DocDetailHeader(props: DocDetailHeaderProps) {
  const {
    activeTab, setActiveTag, onClose,
  } = props;

  const handleClickTag = (tab: number) => () => setActiveTag(tab);

  return (
    <div className={styles.root}>
      <div className={[styles.tab, activeTab === 0 ? styles.active : ''].join(' ')} role="button" tabIndex={0} onClick={handleClickTag(0)}>
        詳細情報
      </div>
      <div className={[styles.tab, activeTab === 1 ? styles.active : ''].join(' ')} role="button" tabIndex={0} onClick={handleClickTag(1)}>
        操作履歴
      </div>
      <div className={[styles.tab, styles.tabFill].join(' ')} />
      <div className={styles.buttons}>
        <div className={styles.icon} role="button" tabIndex={0} onClick={onClose}>
          <img src="/images/xmark-solid-full.svg" alt="" height={22} />
        </div>
      </div>
    </div>
  );
}

export default DocDetailHeader;
